export default {
  namespaced: true,
  bosch: {
    title: "Bosch",
    profiles: "Perfiles",
    profile: "Perfil",
    rules: "Reglas",
    alarms: "Alarmas",
    panels: "Paneles",
    logs: "Registros",
    panel: "Panel",
    name: "Nombre",
    panelHost: "Host del Panel",
    panelPasscode: "Código de Acceso",
    panelInstance: "Instancia del Panel",
    panelModel: "Modelo del Panel",
    units: "Instalaciones",
    center: "Centro",
    sector: "Sector",
    reseller: "Reseller",
    resellers: "Resellers",
    status: "Estado",
    active: "Activo",
    actions: "Acciones",
    syncStatus: "Sincronizar Estado",
    syncActions: "Sincronizar Acciones",
    syncDevices: "Sincronizar Dispositivos",
    copyPassword: "Copiar Contraseña",
    syncing: "Sincronizando...",
    syncCorrectly: "Sincronizado correctamente",
    connected: "Conectado",
    disconnected: "Desconectado",
    armPanel: "Armar Panel",
    disarmPanel: "Desarmar Panel",
    arming: "Armando...",
    disarming: "Desarmando...",
    armedCorrectly: "Armado correctamente",
    disarmedCorrectly: "Desarmado correctamente",
    description: "Descripción",
    deviceType: "Tipo de Dispositivo",
    deviceId: "ID de Dispositivo",
    area: "Nombre de Área",
    areaId: "ID Área",
    eventType: "Tipo de Evento",
    userId: "ID de Usuario",
    username: "Nombre de Usuario",
    alarmId: "ID de Alarma",
    eventDate: "Fecha del Evento",
    devices: "Dispositivos",
    panelOffline: "Panel Desconectado",
    panelStatusArmed: "Armado",
    panelStatusDisarmed: "Desarmado",
    panelStatusOffline: "Desconectado",
    eventDefinition: "Definición de Evento",
    eventCode: "Código de Evento",
    alarmType: "Tipo de Alarma",
    typeAlarm: "Tipo de Alarma",
    deviceName: "Nombre del Dispositivo",
    dispatchAlarm: "Despachar Alarma",
    wizard: {
      add: {
        title: "Agregar Panel Bosch"
      },
      edit: {
        title: "Editar Panel Bosch"
      },
      steps: {
        general: "General"
      }
    },
    messages: {
      areYouSure: "¿Estás seguro de %action% %device_type% %device%?",
      commandExecutedSuccess: "Comando %command% ejecutado correctamente",
      commandExecutedError: "Error al ejecutar el comando %command%",
      executeCommandConfirm: "Ejecutar Comando",
      processing: "Procesando..."
    },
    devices: {
      devices: "Dispositivos",
      update: "Actualizar",
      error_loading_devices: "Error al cargar dispositivos",
      retry: "Reintentar",
      panel_information: "Información del Panel",
      areas: "Áreas",
      zones: "Zonas",
      outputs: "Salidas",
      doors: "Puertas",
      no_devices_found: "No se encontraron dispositivos",
      synchronize_panel_first: "Primero sincroniza el panel para ver los dispositivos",
      area: "Área",
      zone: "Zona",
      output: "Salida",
      door: "Puerta",
      panel: "Panel",
      arm: "Armar",
      disarm: "Desarmar",
      bypass: "Saltar",
      reset: "Restablecer",
      open: "Abrir",
      close: "Cerrar",
      activate: "Activar",
      deactivate: "Desactivar",
      actions_column: "ACCIONES",
      status_column: "ESTADO",
      type_column: "TIPO",
      name_column: "NOMBRE",
      device_id_column: "ID DE DISPOSITIVO",
      area_status: "Estatus de área",
      sync_devices: "Sincronizar Dispositivos",
      go_back: "Regresar"
    }
  }
}
